module.exports = __webpack_public_path__ + "img/load3.d0dcca58.png";